import React from 'react';

import ActivitySetupStepAddressVerification from '../../components/Analyzing/StepAddressVerification';



function ActivitySetupStepAddressVerificationView() {
  return (
    <ActivitySetupStepAddressVerification />
  );
}

export default ActivitySetupStepAddressVerificationView;
